export default __webpack_public_path__ + "static/media/celikes1.de40fc59.jpg";